import React, { useState, useRef, useEffect,  useCallback  } from "react";
import { withRouter } from "react-router";
import Webcam from 'react-webcam';
import { makeStyles } from '@material-ui/core/styles';
import {sendFeelingsScreenshots, sendUserInfos} from "../Utils"
import { 
    feelings, 
    questionNumerical, 
    answerNumerical, 
    questionCanadaCulture,
    answercanadaCulture,
    questionLetter,
    tWords,
    fWords,
    questionMemory, 
    questionDefinition,
    googleDefinitionForApagogie,
    googleDefinitionForLallation 
} from "./experiences/EmotionsPerformances/Constants"
import { useHistory } from "react-router-dom";
import Button from '@material-ui/core/Button';
import Header from "./Header";
// import Test from "./TestComponents/TestHeadorTail";

//Ceci est le premier écran de l'expérience d'Intelligence Emotionnelle.
//On y invite l'utilisateur à se imiter des émotions et se prendre en photo.
//C'est également dans ce fichier que l'on choisit aléatoirement les questions pour la suite du test.
//On y associe également les réponses

function Home(props)  {

    const [username, setUsername] = useState('')

    //Création d'un username lors de l'accès à une expérience.
      useEffect( ()=>{
        var userpseudo = '';
        var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < 8; i++ ) {
            userpseudo += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        console.log(userpseudo)
        setUsername(userpseudo)
      },[]);

    const classes = useStyles();
    const history = useHistory();
    const [tileData, setTileData]=useState([])
    const [errorMessage, setErrorMessage]= useState('')
    const [userEmail, setUserEmail]=useState('')
    const [step,setStep] = useState('infos')// peut mettre test pour skipper la webcam
    const [compteurScreenshots, setCompteur]=useState(1)
    const [currentFeeling,setCurrentFeeling]=useState(feelings[compteurScreenshots-1])

    //TODO : déplacer cette fonction plus en amont dans le scénario nominal
    const defineQuestions=()=>{
        /*On crée un dictionnaire avec les questions et les réponses aléatoirement piochées. 
        Certaines tâches ne changent pas selon la série et ne sont donc pas concernées.
        Voici l'architecture du dictionnaire de chacune des deux séries. 
        */
        const firstSerie = {
            "Questions": {
                "numerical": null,
                "canadaCulture": [], 
                "letter": null,
                "memory": null, 
                "definition": null
            }, 
            'Answers': {
                "numerical": null,
                "canadaCulture": [],
                'letter': null,
                "memory": null, 
                "definition": null
            }
        }
        const secondSerie = {
            "Questions": {
                "numerical": null,
                "canadaCulture":[], 
                "letter":null,
                "memory":null, 
                "definition":null
            }, 
            'Answers': {
            "numerical": null,
            "canadaCulture": [],
            'letter': null,
            "memory": null, 
            "definition": null
            }
        }

        var rand = Math.floor(Math.random() * Math.floor(2))
        var randNumerical = rand        
        firstSerie["Questions"]["numerical"] = questionNumerical[rand]
        firstSerie["Answers"]["numerical"] = answerNumerical[rand]
        secondSerie["Questions"]["numerical"] = questionNumerical[(rand+1)%2]
        secondSerie["Answers"]["numerical"] = answerNumerical[(rand+1)%2]

        var rand2 = [];
        while(rand2.length < 6){
            var r = Math.floor(Math.random() * 13) + 1;
            if(rand2.indexOf(r) === -1) rand2.push(r);
        }
        firstSerie["Questions"]["canadaCulture"][0] = questionCanadaCulture[rand2[0]]
        firstSerie["Answers"]["canadaCulture"][0] = answercanadaCulture[rand2[0]]
        firstSerie["Questions"]["canadaCulture"][1] = questionCanadaCulture[rand2[1]]
        firstSerie["Answers"]["canadaCulture"][1] = answercanadaCulture[rand2[1]]
        firstSerie["Questions"]["canadaCulture"][2] = questionCanadaCulture[rand2[2]]
        firstSerie["Answers"]["canadaCulture"][2] = answercanadaCulture[rand2[2]]

        secondSerie["Questions"]["canadaCulture"][0] = questionCanadaCulture[rand2[3]]
        secondSerie["Answers"]["canadaCulture"][0] = answercanadaCulture[rand2[3]]
        secondSerie["Questions"]["canadaCulture"][1] = questionCanadaCulture[rand2[4]]
        secondSerie["Answers"]["canadaCulture"][1] = answercanadaCulture[rand2[4]]
        secondSerie["Questions"]["canadaCulture"][2] = questionCanadaCulture[rand2[5]]
        secondSerie["Answers"]["canadaCulture"][2] = answercanadaCulture[rand2[5]]

        var rand3 = Math.floor(Math.random() * Math.floor(2))
        firstSerie["Questions"]["letter"] = questionLetter[rand3]
        secondSerie["Questions"]["letter"] = questionLetter[(rand3+1)%2]

        if(firstSerie["Questions"]["letter"] === 't'){
            firstSerie["Answers"]["letter"] = tWords
            secondSerie["Answers"]["letter"] = fWords
        }else{
            firstSerie["Answers"]["letter"] =fWords
            secondSerie["Answers"]["letter"] = tWords
        }

        var rand4 = Math.floor(Math.random() * Math.floor(2))
        firstSerie["Questions"]["memory"] = questionMemory[rand4]
        secondSerie["Questions"]["memory"] = questionMemory[(rand4+1)%2]

        //Cette question dépend également de la question choisie pour les suites numériques. Il y a donc 4 possibilités de réponses
        if(randNumerical === 0){ //On vérifie la série choisie pour la question sur les suites numériques en regardant la première réponse
            if(rand4===0){ 
                firstSerie["Answers"]["memory"] = '4' //Le deuxième nombre de la deuxième suite numérique (question mémory 1) de la suite choisie pour cette série (question numerical 1) est 4
                secondSerie["Answers"]["memory"] = '240'
            }else {
                firstSerie["Answers"]["memory"] = '121'
                secondSerie["Answers"]["memory"] = '300'
            }
        }else{
            if(rand4===0){ 
                firstSerie["Answers"]["memory"] = '300'
                secondSerie["Answers"]["memory"] = '121'
            }else {
                firstSerie["Answers"]["memory"] = '240'
                secondSerie["Answers"]["memory"] = '4'
            }
        }


        rand = Math.floor(Math.random() * Math.floor(2))
        firstSerie["Questions"]["definition"] = questionDefinition[rand]
        secondSerie["Questions"]["definition"] = questionDefinition[(rand+1)%2]

        if(firstSerie["Questions"]["definition"] === 'lallation'){
            firstSerie["Answers"]["definition"] = googleDefinitionForLallation
            secondSerie["Answers"]["definition"] = googleDefinitionForApagogie
        }else{
            firstSerie["Answers"]["definition"] = googleDefinitionForApagogie
            secondSerie["Answers"]["definition"] = googleDefinitionForLallation
        }

        return [firstSerie, secondSerie]
    }

    const videoConstraints = {
        width: 550,
        height: 360,
        facingMode: "user"  
        };
        
    const webcamRef = useRef(null);
    
    const capture = useCallback(
        () => {
            const imageSrc = webcamRef.current.getScreenshot({width: 550, height: 360});
            setCurrentFeeling(feelings[compteurScreenshots])
            setTileData(tileData => [...tileData, {img : imageSrc, title:feelings[compteurScreenshots-1]}])
            setCompteur(compteurScreenshots+1)
            if(compteurScreenshots === feelings.length){
                sendResult()
            }
        },
        [webcamRef, compteurScreenshots ]
    );

    const startExpe= () => {
        if(step === "infos"){
            if(validateForm()){
                setStep("screens")
                sendUserInfos(username, userEmail)
                setErrorMessage('')
            }
        }  
    }


    function validateForm(){
        var isValid=true

        const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        if(!regex.test(userEmail)){
            isValid = false
            setErrorMessage("Merci de rentrer un format d'adresse mail valide")
        }
       
        return isValid

    }

    function handleUserEmail(e){
        setUserEmail(e.target.value)
        
    }


    //On appelle la fonction permettant d'envoyer les résultats à écrire en BD (grâce à un appel à l'API)
    //On appelle également la fonction permettant d'ajouter en BD le username et son email
    //Ensuite on passe à la suite de l'expérience en renseignant les questions réponses pour les 2 séries
    const sendResult=()=>{
        for (var i=0; i<tileData.length; i++){
            sendFeelingsScreenshots(username, tileData[i]['title'],tileData[i]['img'] )
        }
        
        var series = defineQuestions()
        history.push({pathname:"/experience/EmotionsPerformances",
            user : username,
            actualSerie : series[0],
            nextSerie : series[1]
            })
    }
    
    const sendResultTest=()=>{
      var series = defineQuestions()
      history.push({pathname:"/experience/EmotionsPerformances",
          user : username,
          actualSerie : series[0],
          nextSerie : series[1]
          })
    }

return (
    <div className={classes.root}>
        <Header/>
        { step === 'test' ?
          <Button onClick={sendResultTest} color="primary">Go</Button>:
          null
        }
        {/* <Test></Test> */}
        { step === 'infos' ? 
        <div className="description-container">
          <h1>ULaval Expériences</h1>
          <div className="carousel-paragraph">
            <div>
              <input className="email-input" type="text" placeholder="Adresse courriel" name="userEmail" autoComplete="off" onKeyPress={(e) => {if (e.key === 'Enter') {startExpe()}}} value={userEmail} onChange={e=> handleUserEmail(e)}/>
            </div>
            <div>
              <p style={{ color: 'red' }}>{errorMessage}</p>
              <Button variant="outlined" color="primary" className={classes.button} onClick={startExpe}>
                Débuter
              </Button> 
            </div>
          </div>
        </div>: 
          null 
        }
        
        { step === "screens" ? 
        <div className="webcam-page-container" >
          <p>
            Veuillez vous prendre en photo à l'aide du bouton "Capturer" en réalisant une expression représentant :
          </p>
          <p className='feeling-announcement'> 
            {currentFeeling}
          </p>
          <div className="webcam-container">
            <Webcam
              audio={false}
              height={360}
              ref={webcamRef}
              mirrored={true}
              screenshotFormat="image/jpeg"
              width={640}
              videoConstraints={videoConstraints}
            />
            <svg viewBox="0 0 550 360" xmlns="http://www.w3.org/2000/svg" className="face-overlay">
              <ellipse cx="275" cy="150" rx="70" ry="90"
                strokeDasharray="10,10" d="M5 40 l215 0"
                stroke="yellow" strokeWidth="2"
                fillOpacity={0}
              />
            </svg>
          </div>
        </div>: 
          null
        }

        { step === "screens" ? 
          <div>
            <Button 
              variant="outlined" 
              color="primary" 
              onClick={capture} 
              autoFocus={true} 
              className={classes.button}>
                Capturer
            </Button>
          </div>: 
            null
        }

    </div>
    )

}

const useStyles = makeStyles({
    button:{
      'margin-top': '15px',
      'margin-bottom': '15px',
    },
    root: {
        display: 'flex',
        flexDirection:"column",
        justifyContent:'center',
        alignItems : 'center',
        
      },
      gridList: {
        width: 500,
        height: 450,
      },
    form:{
        backgroundColor : '#ECE8E7',
        padding:15,
        border : 'solid',
        borderColor : "#C0C0C0",
        borderRadius: 25
    },
})

 
export default withRouter(Home);